<template>
    <button
        class="cz3__icon-button"
        :class="{
            'cz3__icon-button--important': important,
            'cz3__icon-button--selected': selected,
        }"
        :disabled="disabled"
        @click.prevent="click"
        :aria-label="label"
        :aria-selected="selected"
    >
        <span class="cz3__icon-button__icon">
            <slot/>

            <span class="cz3__icon-button__selected">
            </span>
        </span>

        <span class="cz3__icon-button__label">
            {{label}}
        </span>
    </button>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__icon-button {
            flex: 0 0 auto;

            position: relative;

            display: flex;
            justify-content: center;
            align-items: center;

            width: 64px;
            height: 120px;

            border: none;
            background: transparent;

            @include respond-above(sm) {
                // TODO: Fix this.
                width: 60px;
            }

            &:focus {
                outline: none;

                .cz3__icon-button__icon {
                    outline: 2px solid #000;
                    outline-offset: 2px;
                }
            }

            &:disabled {
                opacity: 0.2;
            }

            &.cz3__icon-button--selected {
                .cz3__icon-button__selected {
                    opacity: 1;
                }
            }

            &.cz3__icon-button--important {
                @include respond-above(sm) {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    width: 100%;
                    height: 72px;

                    border-radius: 8px;

                    background: #f5f5f5;

                    .cz3__icon-button__icon {
                        flex: 0 0 auto;

                        position: static;
                    }

                    .cz3__icon-button__label {
                        display: block;
                        flex: 1 1 0;

                        position: relative;

                        top: 0;

                        font-family: $font-main;
                        font-weight: 700;
                        font-size: 16px;

                        text-align: left;
                    }

                    &:focus {
                        outline: 2px solid #000;
                        outline-offset: 2px;

                        .cz3__icon-button__icon {
                            outline: none;
                        }
                    }
                }
            }
        }

        .cz3__icon-button__selected {
            position: absolute;

            left: -4px;
            top: -4px;
            right: -4px;
            bottom: -4px;

            border: 2px solid #000;

            border-radius: 12px;

            opacity: 0;

            transition: opacity 0.1s ease-out;
        }

        .cz3__icon-button__icon {
            position: absolute;

            display: flex;
            justify-content: center;
            align-items: center;

            left: 0;
            top: 0;

            width: 64px;
            height: 64px;

            border-radius: 8px;

            background: #f5f5f5;
        }

        .cz3__icon-button__label {
            position: absolute;

            left: 0px;
            width: 100%;

            display: flex;
            justify-content: center;

            top: 72px;

            text-align: center;

            font-family: $font-main;
            font-weight: 400;
            font-size: 12px;

            color: #000;
        }

        .cz3__icon-button--important {
            .cz3__icon-button__label {
                font-weight: 700;
                font-size: 14px;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            label: String,
            selected: {
                type: Boolean,
                required: false,
                default: null,
            },
            important: Boolean,
            disabled: Boolean,
        },

        methods: {
            click() {
                this.$emit('click');
            },
        },
    };
</script>
